import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import FilledInput from '@material-ui/core/FilledInput'
import TextField from '@material-ui/core/TextField'

import { makeStyles } from '@material-ui/core/styles'

import { handleEmailContents, handleEmailParser, handleTextPrepper, ValidateEmail } from '../../../../utils'

import { EmailMask } from '../../tools/TextMasks'

import { updateOrgEmailTemplates } from '../../../../redux/actions'

import { NotificationToast } from '../../tools/Toast'

import { useQuill } from 'react-quilljs'
import 'quill/dist/quill.snow.css'

const theme = 'snow'

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: [] }],

    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],

    [{ size: ['small', false, 'large', 'huge'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['link'],
    [{ color: [] }, { background: [] }],

    ['clean']
  ]
}

const placeholder = 'Sample text...'

const formats = [
  'bold', 'italic', 'underline', 'strike',
  'align', 'list', 'indent',
  'size', 'header', 'link',
  'color', 'background',
  'clean'
]

const useStyles = makeStyles((theme) => ({
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

/**
 * Returns organization email template forms
 */
const OrganizationEmail = (props) => {
  const classes = useStyles()
  const textClasses = useTextStyles()
  const dispatch = useDispatch()

  const welcomeEmailTemplate = useSelector(state => state.orgEmail.welcomeEmailTemplate)
  const alertEmailTemplate = useSelector(state => state.orgEmail.alertEmailTemplate)
  const sourceEmailAddress = useSelector(state => state.orgEmail.sourceEmailAddress)
  const sourceEmailName = useSelector(state => state.orgEmail.sourceEmailName)

  const [sourceEA, setSourceEA] = useState('')
  const [sourceEN, setSourceEN] = useState('')

  const initWelcomeQuill = useQuill({ theme, modules, formats, placeholder })
  const welcomeQuill = initWelcomeQuill.quill
  const welcomeQuillRef = initWelcomeQuill.quillRef

  const initAlertQuill = useQuill({ theme, modules, formats, placeholder })
  const alertQuill = initAlertQuill.quill
  const alertQuillRef = initAlertQuill.quillRef

  useEffect(() => {
    if (sourceEmailAddress) {
      setSourceEA(sourceEmailAddress)
    }
    if (sourceEmailName) {
      setSourceEN(sourceEmailName)
    }
  }, [sourceEmailAddress, sourceEmailName])

  useEffect(() => {
    if (welcomeEmailTemplate && welcomeQuill) {
      const welcomeQuillContent = handleEmailParser(welcomeEmailTemplate)
      welcomeQuill.setContents(welcomeQuillContent)
    }
    if (alertEmailTemplate && alertQuill) {
      const alertQuillContent = handleEmailParser(alertEmailTemplate)
      alertQuill.setContents(alertQuillContent)
    }
  }, [alertQuill, alertEmailTemplate, welcomeQuill, welcomeEmailTemplate])

  const handleSave = () => {
    if (!ValidateEmail(sourceEA)) {
      NotificationToast(false, 'Invalid source email address!', true)
    } else {
      let welcomeContents = []
      let alertContents = []
      if (welcomeQuill) {
        const welcomeQuillLength = welcomeQuill.getLength()
        welcomeContents = welcomeQuill.getContents(0, welcomeQuillLength).ops
      }
      if (alertQuill) {
        const alertQuillLength = alertQuill.getLength()
        alertContents = alertQuill.getContents(0, alertQuillLength).ops
      }
      if (welcomeContents.length !== 0 && alertContents.length !== 0) {
        const welcomeSendContent = handleEmailContents(welcomeContents)
        const alertSendContent = handleEmailContents(alertContents)
        const sourceEmailAddress = handleTextPrepper(sourceEA)
        const sourceEmailName = handleTextPrepper(sourceEN)
        dispatch(updateOrgEmailTemplates(welcomeSendContent, alertSendContent, sourceEmailAddress, sourceEmailName, fireSuccess, fireFailure))
      }
    }
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Successfully updated email templates!')
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to update templates')
  }

  return (
    <Grid container direction='column'>

      <Grid container item direction='row' spacing={2} className='mx-auto w-100 my-auto'>
        <Grid item xs={8}>
          <h2 className='my-auto'>
            Email Templates
          </h2>
        </Grid>

        <Grid item xs={4} container direction='row' justify='flex-end'>
          <Button variant='contained' className={classes.blueBtn} onClick={handleSave}>
            Save
          </Button>
        </Grid>
      </Grid>

      <Grid container item direction='row' spacing={4} className='mx-auto w-100 my-auto'>
        <Grid item xs={6}>
          <FormControl fullWidth className=''>
            <InputLabel
              htmlFor='email-input'
              variant='filled'
              required
            >
              Source Email Address
            </InputLabel>
            <FilledInput
              id='email-input'
              name='emailInput'
              onChange={(e) => setSourceEA(e.target.value)}
              value={sourceEA}
              color='primary'
              required
              error={!ValidateEmail(sourceEA)}
              // className={classes.phoneInput}
              classes={textClasses}
              fullWidth
              inputComponent={EmailMask}
            />
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <TextField
            label='Source Email Name'
            name='sourceEmailName'
            variant='filled'
            value={sourceEN}
            onChange={(e) => setSourceEN(e.target.value)}
            InputProps={{
              classes: textClasses
            }}
            fullWidth
            className=''
          />
        </Grid>
      </Grid>

      <Grid container item direction='row' spacing={2} className='mx-auto w-100 my-auto'>
        <Grid item xs={12}>
          <h5>Welcome Email</h5>
          <div className='mb-5' style={{ height: 300 }}>
            <div ref={welcomeQuillRef} />
          </div>
        </Grid>
      </Grid>

      <Grid container item direction='row' spacing={2} className='mx-auto w-100 my-auto'>
        <Grid item xs={12}>
          <h5>Alert Email</h5>
          <div className='mb-5' style={{ height: 300 }}>
            <div ref={alertQuillRef} />
          </div>
        </Grid>
      </Grid>

      <Grid container item direction='row' spacing={2} justify='flex-end' className='mx-auto w-100 my-auto'>
        <Grid item xs={4} container direction='row' justify='flex-end'>
          <Button variant='contained' className={classes.blueBtn} onClick={handleSave}>
            Save
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OrganizationEmail
